import React, { Component } from "react";
import { Link } from "react-router-dom";

class ItemNameCellRenderer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cellValue: ItemNameCellRenderer.getValueToDisplay(props),
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      cellValue: ItemNameCellRenderer.getValueToDisplay(nextProps),
    };
  }

  getReactContainerStyle() {
    return {
      //   display: 'inline-block',
      height: "100%",
    };
  }

  render() {
    if (typeof this.state.cellValue === "string") {
      return (
        <div className="">
          <h5 className="font-size-14 mt-2 ">{this.state.cellValue}</h5>
        </div>
      );
    } else {
      return (
        <div className="">
          <h5 className="font-size-14 mt-1 ">
            <Link to="#" className="text-dark">
              {this.state.cellValue.Name}
            </Link>
          </h5>
          <span className="mt-0">
            Quantity :{"  "}
            <span className="font-weight-medium">
              {this.state.cellValue.Quantity}{" "}
              {this.state.cellValue.Quantity_unit.name}
            </span>
          </span>
          <br />
          <span className="mt-0">
            PO Quantity :{"  "}
            <span className={" font-weight-medium "}>
              {this.state.cellValue.totalpoqty}{" "}
              {this.state.cellValue.Quantity_unit.name}{" "}
              {/* PO Units are the same as Quantity_unit */}
            </span>
          </span>
          <br />
          <span className="mt-0">
            Balance Quantity : {"  "}
            <span className={" font-weight-medium font-size-16"}>
              {this.state.cellValue.Quantity - this.state.cellValue.totalpoqty}{" "}
              {this.state.cellValue.Quantity_unit.name}{" "}
              {/* PO Units are the same as Quantity_unit */}
            </span>
          </span>
          <br />
          <span className="mt-0">
            Entered Quantity : {"  "}
            <span
              className={
                this.state.cellValue.totalqty >
                this.state.cellValue.Quantity - this.state.cellValue.totalpoqty
                  ? "text-danger font-weight-medium font-size-16"
                  : " font-weight-medium font-size-16"
              }
            >
              {this.state.cellValue.totalqty}{" "}
              {this.state.cellValue.Quantity_unit.name}
            </span>
          </span>
        </div>
      );
    }
  }
  static getValueToDisplay(params) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}

export default ItemNameCellRenderer;
